import Vue from "vue";
import { Component } from "vue-property-decorator";
import { SalarieNotesDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieNotesDto";
import { ActiviteDto } from "../../../dto/GenApi.iNotPaie.Dto/ActiviteDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { EventBus } from "../../Controls/EventBus";
import { ParametresInstance } from "../../Controls/Parameters";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface modelBlocnoteSalarie {
	route: string;
	errorMessage: string[];
	isModified: boolean;
	salarieCourant: SalarieNotesDto;
	// eslint-disable-next-line no-use-before-define
	notes: modelNotes[];
	modifEnCours: boolean;
}

interface modelNotes {
	note: ActiviteDto;
	modifEnCours: boolean;
}

@Component
export default class BlocnoteSalarieComponent extends Vue {
	public canModify = false;

	public currentId = 0;
	public dataReady = false;
	public salarieCourant: SalarieNotesDto = { Id: 0, Notes: [] };
	public salarieCharges: modelBlocnoteSalarie[] = [];
	public notes: modelNotes[] = [];
	public errorMessage: string[] = [];
	public isModified = false;
	public modifEnCours = false;
	public previewDetails?: string = "";

	public reloadData(id: number): void {
    	if (this.currentId > 0) {
			this.salarieCharges[this.currentId] = {
    			modifEnCours: this.modifEnCours,
    			notes: this.notes,
    			salarieCourant: this.salarieCourant,
    			errorMessage: this.errorMessage,
    			route: this.$router.currentRoute.path,
    			isModified: this.isModified
    		};
		}
    	this.currentId = id;
    	this.fetchData();
	}

	public resetData(id: number): void {
    	if (this.salarieCharges[id] != undefined) {
    		this.salarieCharges[id].isModified = false;
    	}
    	if (this.currentId == id) {
    		this.fetchData();
    	}
	}

	public mounted(): void {
    	EventBus.$on(EventConstants.UTILISATEUR_CHANGED, this.fetchData);
	}

	public fetchData(): void {
    	if (ParametresInstance.utilisateurCourant == undefined) {
			return;
		}
    	this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);

    	if (this.currentId < 1) {
			return;
		}
    	this.dataReady = false;
    	if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
    		ServicesFactoryInstance.SalarieService.getNotes(this.currentId, data => {
				if (data.Id != this.currentId) {
					return;
				}

    			this.salarieCourant = data;

    			this.$emit("counterNotes", data.Notes.length);

    			this.notes = [];
    			for (let i = 0; i < this.salarieCourant.Notes.length; i++) {
    				this.notes.push({ note: this.salarieCourant.Notes[i], modifEnCours: false });
    			}
    			this.isModified = false;
    			this.dataReady = true;
    			this.modifEnCours = false;
    		});
    	} else {
    		this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
    		this.isModified = this.salarieCharges[this.currentId].isModified;
    		this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
    		this.notes = this.salarieCharges[this.currentId].notes;
    		this.$emit("counterNotes", this.notes.length);
    		this.modifEnCours = this.salarieCharges[this.currentId].modifEnCours;
    		this.dataReady = true;
    	}
	}

	public deleteNote(note: modelNotes): void {
    	this.salarieCourant.Notes = this.salarieCourant.Notes.filter(n => (n.Id != note.note.Id && n.Id != 0) || (n.Id == 0 && note.note.Id == 0 && n.Details != note.note.Details));
    	this.notes = this.notes.filter(n => (n.note.Id != note.note.Id && n.note.Id != 0) || (n.note.Id == 0 && note.note.Id == 0 && n.note.Details != note.note.Details));
    	this.modify();
    	this.$emit("counterNotes", this.notes.length);
	}

	public addNote(): void {
    	const newNote = { Id: 0, Date: new Date(), Details: "" };
    	this.salarieCourant.Notes.unshift(newNote);
    	this.notes.unshift({ modifEnCours: true, note: newNote });
    	this.modifEnCours = true;
    	this.$emit("counterNotes", this.notes.length);
	}

	public editNote(note: modelNotes): void {
    	note.modifEnCours = true;
    	this.modifEnCours = true;
    	this.previewDetails = note.note.Details != undefined ? note.note.Details.toString() : "";
	}

	public validateModif(note: modelNotes): void {
    	note.modifEnCours = false;
    	this.modifEnCours = false;
    	this.modify();
	}

	public cancelModif(note: modelNotes): void {
    	note.modifEnCours = false;
    	this.modifEnCours = false;
    	note.note.Details = this.previewDetails;
	}

	public modify(): void {
    	this.isModified = false;
    	this.isModified = true;
    	this.$emit("isModified", true);
	}

	public enregistrer(): boolean {
    	this.dataReady = false;
    	ServicesFactoryInstance.SalarieService.updateNotes(this.salarieCourant, () => {
    		this.$emit("isModified", false);
    		this.isModified = false;
    		this.dataReady = true;
    		NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
        }, () => { this.dataReady = true; });

    	return false;
	}

	public annuler(): void {
    	this.fetchData();
    	this.isModified = false;
    	this.$emit("isModified", false);
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/blocnote/blocnote.ts